import {useEffect} from "react";
import {bffApi} from "./features/chat/bffApi";
import {chatApi} from "./features/chat/chatApi";

export const Intercom = () => {
    const userData = bffApi.endpoints.getUser.useQuery();
    const intercomInfoQuery = chatApi.endpoints.getIntercomInfo.useQuery(
        undefined,
        {skip: !userData.isSuccess}
    );
    useEffect(() => {
        if (intercomInfoQuery.isSuccess && intercomInfoQuery.data) {
            // Never set custom_launcher_selector here: it makes the first click
            // on the default lightweight launcher open-and-immediately-close the
            // messenger. In-app "contact us" links call openIntercom() instead.
            const config = {
                ...intercomInfoQuery.data,
                hide_default_launcher: false,
            };

            (window as any).intercomConfig = config;

            if ((window as any).Intercom) {
                (window as any).Intercom("update", config);
                (window as any).Intercom("trackEvent", "ai-chat-login");
            }
        }
    }, [intercomInfoQuery.fulfilledTimeStamp]);

    return <div />;
};
